import React from 'react';

interface StatTileProps {
  label: string;
  value: string | number;
  subtext?: string;
}

const StatTile: React.FC<StatTileProps> = ({ label, value, subtext }) => {
  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4">
      <div className="text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide truncate">
        {label}
      </div>
      <div className="mt-1 text-2xl font-semibold text-gray-900 dark:text-gray-100 tabular-nums">
        {value}
      </div>
      {subtext && (
        <div className="mt-0.5 text-xs text-gray-400 dark:text-gray-500">{subtext}</div>
      )}
    </div>
  );
};

export default StatTile;
